import RulesRequests from '../../server/punchOutRules';
import { addLoading, removeLoading } from './loading';

export const setPunchOutRules = res => ({
  type: 'PANEL_GET_PUNCHOUT_RULES',
  punchOutRules: res,
});

const createPunchOutRule = rule => async (dispatch) => {
  dispatch(addLoading());
  try {
    await RulesRequests.createPunchOutRule(rule);
  } finally {
    dispatch(removeLoading());
  }
};

const updatePunchOutRule = rule => async (dispatch) => {
  dispatch(addLoading());
  try {
    await RulesRequests.updatePunchOutRule(rule);
  } finally {
    dispatch(removeLoading());
  }
};

const getPunchOutRules = (limit, skip, force = false, order = '', field = '') => async (dispatch) => {
  if (force) dispatch(addLoading());
  try {
    const rules = await RulesRequests.getPunchOutRules(limit, skip, order, field);
    dispatch(setPunchOutRules(rules));
  } finally {
    if (force) dispatch(removeLoading());
  }
};

export default {
  createPunchOutRule,
  getPunchOutRules,
  updatePunchOutRule,
};
